import { useState } from 'react';
import { useLocation } from 'react-router';

import Collapse from '@mui/material/Collapse';
import Alert, { alertClasses } from '@mui/material/Alert';

const ENVIRONMENT_BANNER_MESSAGE = `${process.env.NODE_ENV === 'uat' ? 'Staging Envionrment' : 'Development Environment'} - For Testing Purposes Only`;

function EnvironmentBanner() {
  const [open, setOpen] = useState(true);
  const location = useLocation();

  // Avoid showing the banner on the summary page to prevent click issues
  if (process.env.NODE_ENV === 'prod' || location.pathname.includes('/summary')) {
    return null;
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Collapse in={open}>
      <Alert
        icon={false}
        severity="warning"
        sx={{
          position: 'sticky',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 999,
          width: '100%',
          [`& .${alertClasses.message}`]: {
            width: '100%',
            textAlign: 'center',
          },
        }}
        onClose={handleClose}
      >
        {ENVIRONMENT_BANNER_MESSAGE}
      </Alert>
    </Collapse>
  );
}

export default EnvironmentBanner;
